/**
 * 邮箱验证页：通过 token 验证后设置用户名与密码
 */

import { useEffect, useState } from 'react'
import { verifyEmailToken, setCredentials } from '../api'

function getTokenFromUrl(): string {
  const params = new URLSearchParams(window.location.search)
  return params.get('token') || ''
}

export default function Verify() {
  const [token, setToken] = useState('')
  const [email, setEmail] = useState('')
  const [checking, setChecking] = useState(true)
  const [valid, setValid] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    const t = getTokenFromUrl()
    setToken(t)
    if (!t) {
      setChecking(false)
      setError('验证链接缺少 token，请重新注册')
      return
    }
    verifyEmailToken(t)
      .then((res) => {
        setEmail(res.email)
        setValid(true)
      })
      .catch((err) => setError(err instanceof Error ? err.message : '验证链接无效'))
      .finally(() => setChecking(false))
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (!username.trim() || username.trim().length < 2) {
      setError('用户名长度至少 2 位')
      return
    }
    if (password.length < 6) {
      setError('密码长度至少 6 位')
      return
    }
    if (password !== confirmPassword) {
      setError('两次输入的密码不一致')
      return
    }
    setSubmitting(true)
    try {
      await setCredentials(token, username.trim(), password)
      window.location.href = '/member'
    } catch (err) {
      setError(err instanceof Error ? err.message : '设置失败')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-50 via-sky-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white/80 backdrop-blur-xl rounded-3xl shadow-[0_12px_40px_-12px_rgba(100,116,139,0.2)] border border-white/60 p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-sky-500 to-indigo-500 text-white text-3xl mb-4 shadow-lg shadow-sky-300/40">
            🔐
          </div>
          <h1 className="text-2xl font-bold text-slate-800">邮箱验证</h1>
          <p className="text-slate-500 text-sm mt-1">验证成功，请设置你的登录信息</p>
        </div>

        {checking ? (
          <div className="text-center py-8 text-slate-500 text-sm">正在验证链接...</div>
        ) : error && !valid ? (
          <div className="rounded-2xl bg-rose-50 border border-rose-200 p-6 text-center">
            <div className="text-3xl mb-2">⚠️</div>
            <p className="text-sm text-rose-700 mb-4">{error}</p>
            <a
              href="/register"
              className="inline-block px-5 py-2 rounded-xl bg-rose-600 hover:bg-rose-700 text-white text-sm font-semibold transition-colors"
            >
              重新注册
            </a>
          </div>
        ) : (
          <>
            {error && (
              <div className="mb-4 rounded-xl bg-rose-50 border border-rose-200 px-4 py-3 text-sm text-rose-700">
                {error}
              </div>
            )}
            <div className="mb-5 rounded-xl bg-sky-50 border border-sky-100 px-4 py-3 text-sm text-sky-700">
              验证邮箱：<strong>{email}</strong>
            </div>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1.5">用户名</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500/30 focus:border-sky-500 text-sm transition-all"
                  placeholder="设置你的用户名"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1.5">密码</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500/30 focus:border-sky-500 text-sm transition-all"
                  placeholder="设置 6 位以上密码"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1.5">确认密码</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500/30 focus:border-sky-500 text-sm transition-all"
                  placeholder="再次输入密码"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={submitting}
                className="w-full bg-gradient-to-r from-sky-600 to-indigo-600 hover:from-sky-700 hover:to-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-bold py-3 rounded-xl text-sm shadow-lg shadow-sky-200 transition-all"
              >
                {submitting ? '保存中...' : '完成注册并登录'}
              </button>
            </form>
          </>
        )}

        <div className="mt-6 text-center">
          <a href="/" className="text-xs text-slate-400 hover:text-slate-600">
            ← 返回首页
          </a>
        </div>
      </div>
    </div>
  )
}
